define('Contact.ei1.Main.View', [
    'PageType.Base.View',
    'contact_us_page.tpl',
    'Contactus.ei1.Main.View'
], function (
    PageTypeBaseView,
    contact_us_page_tpl,
    ContactusView
) {
    'use strict';

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: contact_us_page_tpl,

        beforeShowContent: function beforeShowContent() {
            this.childViews = {
                'Contactus.ei1.Main.View': function () {
                    return new ContactusView();
                }
            };
            return jQuery.Deferred().resolve();
        }
    });
});
